import { HeroSection } from "./components/HeroSection/HeroSection";
import { NavBar } from "./components/Core/NavBar";
import { ShowcaseSection } from "./components/ShowcaseSection/ShowcaseSection";
import { StatListSection } from "./components/StatListSection/StatListSection";
import { FeatureListSection } from "./components/FeatureListSection/FeatureListSection";
import { Footer } from "./components/Core/Footer";
function App(): JSX.Element {
  const logo = (
    <span 
      className="text-black font-extralight tracking-wider cursor-pointer"
      onClick={() => window.open('https://viewEngine.studio', '_blank')}
    >
      View<span className="text-black font-semibold">Engine</span>
    </span>
  );
  return (
    <div className="bg-black text-white">
      <NavBar
        logo={logo}
        links={
          [
            // <a
            //   key="features"
            //   href="#features"
            //   className="hover:text-cyan-400 transition"
            // >
            //   Features
            // </a>,
            // <a
            //   key="pricing"
            //   href="#pricing"
            //   className="hover:text-cyan-400 transition"
            // >
            //   Pricing
            // </a>,
          ]
        }
      />
      {/*<HeroSection />*/}
      <div className="section-padding py-16 bg-white pt-28 lg:pt-16">
        <h1 className="text-4xl lg:text-6xl font-light text-gray-700 pt-[10px] text-center">
          BRAND NEW DEVELOPMENT IN ZABBAR
        </h1>
      </div>
      <ShowcaseSection />
      <Footer />
    </div>
  );
}

export default App;
